import axios from 'axios'
import api from 'api'
import jsonp from 'jsonp'

import {
  GET_PAGES,
  // GET_BLOG,
  GET_APP,
  GET_INSTAGRAM,
  VIEW_NAV,
  VIEW_BODY,
  VIEW_TYPES,
  COMMUNITY_MODAL,
  VIEW_SHOWMODAL,
  VIEW_MODALCONTENT
} from './mutation-types'

const actions = {
  GET_PAGES ({ commit }) {
    (async () => {
      try {
        const response = await axios.get(`${api}/wp/v2/pages?page=1&per_page=100`)
        const total = response.headers['x-wp-totalpages']
        let page = 1
        while (page < total) {
          page++
          let res = axios.get(`${api}/wp/v2/pages?page=${page}&per_page=100`)
          response.data.concat(res.data)
        }

        const data = response.data.reduce(
          (allData, data) => ({ ...allData, [data.slug]: data }),
          {}
        )
        commit(GET_PAGES, data)
      } catch (e) {
        console.log('PAGES API: ' + e)
      }
    })()
  },
  GET_APP ({ commit }) {
    (async () => {
      try {
        const response = await axios.get(`${api}/wp/v2/app`)
        const data = response.data.reduce(
          (allData, data) => ({ ...allData, [data.slug]: data }),
          {}
        )
        commit(GET_APP, data)
      } catch (e) { console.log('APP API: ' + e) }
    })()
  },
  GET_INSTAGRAM ({ commit }) {
    (async () => {
      try {
        jsonp('https://api.instagram.com/v1/users/2003371644/media/recent?access_token=2003371644.d4fa3eb.6390bb38176e4d7b8c5dcbd0a062be18', null, (err, res) => {
          if (err) {
            console.log(err.message)
          } else {
            commit(GET_INSTAGRAM, res.data)
          }
        })
      } catch (e) {
        console.log(e)
      }
    })()
  },
  // GET_BLOG ({ commit }) {
  //   (async () => {
  //     try {
  //       const response = await axios.get(`${api}/wp/v2/posts?per_page=10&_embed`)
  //       commit(GET_BLOG, response)
  //     } catch (e) {
  //       console.log(e)
  //     }
  //   })()
  // },
  // https://api.instagram.com/v1/users/2003371644/media/recent?access_token=2003371644.bbbc102.f25ce3bcfe3748bc9a36c2f53e202cab
  VIEW_NAV ({ commit }, data) {
    commit(VIEW_NAV, data)
  },
  VIEW_BODY ({ commit }, data) {
    commit(VIEW_BODY, data)
  },
  VIEW_TYPES ({ commit }, data) {
    commit(VIEW_TYPES, data)
  },
  VIEW_SHOWMODAL ({ commit }, data) {
    commit(VIEW_SHOWMODAL, data)
  },
  COMMUNITY_MODAL ({ commit }, data) {
    commit(COMMUNITY_MODAL, data)
  },
  VIEW_MODALCONTENT ({ commit }, data) {
    commit(VIEW_MODALCONTENT, data)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/shared/store/actions.js